import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { Textarea } from 'components/fields'
import styles from './task-email-revise.styl'

@form({
  form: 'taskEmailRevisionNotify'
})
class TaskEmailRevise extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    actionRequest: PropTypes.string.isRequired,
    title: PropTypes.string,
    intlKey: PropTypes.string,
    handleSubmit: PropTypes.func,
    modal: PropTypes.func.isRequired,
    proceed: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    title: 'Revise item',
    intlKey: 'tasks.revise_item'
  }

  handleDismiss = () => this.props.modal(null)

  handleProceed = fields => {
    const { id, actionRequest, proceed } = this.props

    return proceed(id, actionRequest, fields)
      .then(() => this.props.modal(null))
  }

  render() {
    const {
      handleSubmit,
      title,
      intlKey,
      submitting
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleProceed)}>
        <h2 className="text--center">
          <FormattedMessage id={intlKey} defaultMessage={title} />?
        </h2>
        <div className="row">
          <div className={`col-xs-12 ${styles.explanation}`}>
            <FormattedMessage id="label.notify_email_explanation"
                              defaultMessage={'The participant will be notified by email that his assessment'
                              + ' request has not been delivered and'
                              + ' he will be asked to correct the email and ask for assessment again.'}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Textarea name="note" label="Note" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button type="button" secondary onClick={this.handleDismiss}>
              <FormattedMessage id="button.dismiss" defaultMessage="Dismiss" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button isLoading={submitting}>
              <FormattedMessage id="button.revise" defaultMessage="Revise" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default TaskEmailRevise
